/**
 * Synchronisation de l'horloge serveur.
 *
 * Mesure une seule fois au démarrage le décalage entre l'horloge du navigateur
 * et l'horloge du serveur Django (clock skew), puis expose nowServer() qui
 * retourne un timestamp corrigé.
 *
 * Le demi round-trip réseau est soustrait pour affiner la correction.
 */

let _skewMs = 0   // client - serveur (en ms)
let _synced  = false

export async function syncServerTime(): Promise<void> {
  try {
    const t0 = Date.now()
    const res = await fetch('/api/v1/server-time/', { cache: 'no-store' })
    const t1 = Date.now()

    if (!res.ok) return

    const data = await res.json()
    const serverMs = new Date(data.now).getTime()

    // Estimation : heure client au milieu du round-trip ≈ heure vraie du client
    _skewMs = Math.round((t0 + t1) / 2 - serverMs)
    _synced  = true
  } catch {
    // Fallback silencieux : on reste à skew=0 (Date.now() brut)
    _skewMs = 0
    _synced  = false
  }
}

/**
 * Équivalent de Date.now() mais corrigé selon l'heure du serveur.
 * Toujours sûr à appeler même si syncServerTime() n'a pas encore été appelé.
 */
export function nowServer(): number {
  return Date.now() - _skewMs
}

/** Indique si la synchro a réussi (utile pour debug) */
export function isServerTimeSynced(): boolean {
  return _synced
}

/** Décalage mesuré en ms (client - serveur). Positif = client en avance. */
export function getServerSkewMs(): number {
  return _skewMs
}
